import styled from 'styled-components';
import theme from 'src/styles/theme';
import { device } from 'src/styles/global';

export const ActionBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 85px;
  padding: 16px;
  z-index: 998;
  background: ${theme.colors.white0};
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
  padding-right: 200px;
  gap: 16px;

  @media ${device.mobile} {
    flex-direction: column;
    height: 112px;
    padding: 16px 24px;
  }
`;

export const ActionBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 85px;
  padding: 24px;
  z-index: 998;
  background: ${theme.colors.white0};
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
`;

export const SongsSelectedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SelectedSongsStyle = styled.div`
  font-size: 14px;
  padding: 4px 8px;
  color: ${theme.colors.neutralW40};
`;

export const CheckboxStyles = {
  borderColor: theme.colors.neutralW70,
};

export const VerticalLine = styled.div`
  display: flex;
  width: 20px;
  transform: rotate(90deg);
  border: 1px solid ${theme.colors.neutralW80};

  @media ${device.mobile} {
    display: none;
  }
`;

export const PillStyles = {
  fontSize: '14px',
  fontWeight: '700',
  color: theme.colors.mtr60,
  backgroundColor: theme.colors.white0,
  gap: '8px',
};

export const IconContainerStyles = {
  width: '16px',
  height: '16px',
  alignItems: 'center',
};

export const CloseButtondWrapperDesktop = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px;
  border: none;
  border-radius: 50px;
  background-color: white;
  color: ${theme.colors.neutralW40};
  width: 32px;
  height: 32px;
  cursor: pointer;

  &:hover {
    background: ${theme.colors.neutralW100};
  }

  @media ${device.mobile} {
    display: none;
  }
`;

export const CloseButtondWrapperMobile = styled.button`
  display: none;

  @media ${device.mobile} {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px;
    border: none;
    border-radius: 50px;
    background-color: white;
    color: ${theme.colors.neutralW40};
    width: 32px;
    height: 32px;
    cursor: pointer;

    &:hover {
      background: ${theme.colors.neutralW100};
    }
  }
`;

export const TooltipContainerStyles = {
  width: 'fit-content',
  height: '14px',
  fontSize: '12px',
  fontWeight: '700',
  borderRadius: '5px',
  marginTop: '-8px',
};
